/* el-guarantee.js — sections/el-guarantee.liquid
   Add To Cart presses the main product form's button so the variant, plan,
   gifts and discount chosen at the top of the page are used. When there is
   no main form (or it is sold out) the section's own form submits as usual. */
(function () {
  'use strict';

  if (window.elGuaranteeReady) return;
  window.elGuaranteeReady = true;

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('[data-el-guarantee-form]');
    if (!form) return;
    var mainButton = document.querySelector('[data-el-product] [data-el-add]');
    if (!mainButton || mainButton.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    mainButton.click();
  }, true);
})();
